import { storeToRefs } from 'pinia'
import { useCartStore } from '~/stores/useCartStore'
import { useChosenVariantDetailsStore } from '~/stores/useChosenVariantDetailsStore'

/**
 * Shared helper functions for voucher feature
 * Extracted to eliminate code duplication
 */
export const useVoucherHelpers = () => {
  const cartStore = useCartStore()
  const chosenVariantDetailsStore = useChosenVariantDetailsStore()

  const { getCart } = storeToRefs(cartStore)
  const { productDetails, chosenChannel, chosenInstallment } = storeToRefs(chosenVariantDetailsStore)

  const getCartID = () => getCart.value?.id

  const getProductInfo = () => {
    const sku = productDetails.value?.chosenVariantSku
    const isCash = chosenChannel.value?.channelKey === 'Cash'
    const channelKey = isCash ? '' : chosenChannel.value?.channelKey
    const installmentPeriod = isCash ? 0 : (chosenInstallment.value?.months || 0)

    return { sku, channelKey, installmentPeriod }
  }

  return {
    getCartID,
    getProductInfo,
    getCart,
    productDetails,
    chosenChannel,
    chosenInstallment
  }
}
